import * as strs from './commonStrings'
import * as iid from './bookingElementId'
import Modal from './modal'
import { Stack, Box, Typography, Button, Paper, Link } from '@mui/material'
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material/'
import { successPopUpKeyDown } from './snippets'
import { useEffect, useRef, useState, useLayoutEffect } from 'react'
import { ewayBillDateFormat, float, focusElemnt, generateChecksum } from './helper'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import ImageIcon from '@mui/icons-material/Image'
import HideImageIcon from '@mui/icons-material/HideImage'
import { RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { getOtherCharges, getReverseFreight } from './bookingHelper'
import { useAtom } from 'jotai'
import { companySettingsAtom, qrProcessignFees } from './jotaiState/commonStateAtoms'
import { bookingQrUrl, timerAtom } from './atoms'
import { alertAtom, modalAtom } from './jotaiState/globalStateAtoms'
import { useDispatch } from 'react-redux'
import { getDQRDetailsInsertUpdate } from '../../store/booking/booking_action'
import { updateAlertError } from '../../store/common/common_action'
import { GetRequest, PostRequest } from './api'
import QRTimer from '../header/QRTimer'
import { urls } from './constants'

export const BookingConfirm = (props) => {
  const { data, updateModal, loginData } = props
  const { showQr = false, disabledQr = false } = props
  const dispatch = useDispatch()
  const { DefaultCurrencyID = 0 } = data
  const { consignmntData, priceSectionData } = data
  const { strtCity, strtBrnch, sendMobNo, sendName, senGstnNo, senCNnST, destCity, destBrnch, recMobNo } = data
  const { recName, recGstnNo, recCNnST, consignerCheck, consigneeCheck, selBookingType, slctdSndParty, slctdRcvrParty } = data
  const { billNo, billDate, billAmount, ModalData, sendMobNo2, sendMailId, recMobNo2, recMailId, pickupAddressObj } = data
  const { ewayBillNoList, CCR, cmnt, deliveryAddressObj, ewayBillDetailsList, intCompanyID } = data
  const [companySettings] = useAtom(companySettingsAtom)
  const { SetDefaultBookCargo = 0 } = companySettings
  const { RemoveQRTransFeeFromCustAmt = 0 } = companySettings
  const { RemoveCartageremark } = companySettings
  const { RemoveComment } = companySettings
  const { RemovePaymentMode } = companySettings
  const { RemoveAccountnumber } = companySettings
  const { RemoveSenderGSTINEwayBill, RemoveReceiverGSTIN } = companySettings
  const { RemoveSenderID = 0 } = companySettings
  const {
    RemovePickupcartage,
    RemoveMisccartage,
    RemoveBookingDropcartage,
    RemoveHamali,
    RemoveOpHamali,
    RemoveValuation,
    RemoveDocfee,
    RemovePickupfee,
    RemoveDropofffee,
    IsServiceTax,
  } = companySettings

  const IsRateIncludeAllCharge = slctdSndParty?.IsRateIncludeAllCharge ?? (slctdRcvrParty?.IsRateIncludeAllCharge || 0)
  const IsMultipleConsignment = consignmntData.length > 1
  const [QRData, setQRData] = useAtom(bookingQrUrl)
  const [, setModal] = useAtom(modalAtom)
  const [processingFees] = useAtom(qrProcessignFees)
  const [remainingTime, setRemainingTime] = useState(false)
  const [, setAlert] = useAtom(alertAtom)
  var totalUnits, totalDeclaredValue, totalWeight, totalWeightVolume, totalFreight, totalwt_actual
  if (IsMultipleConsignment) {
    totalUnits = consignmntData.reduce((n, { unit }) => n + parseInt(unit), 0)
    totalDeclaredValue = consignmntData.reduce((n, { goods_value }) => n + float(goods_value), 0)
    if (intCompanyID === STA_COMPANY_ID) {
      totalWeightVolume = consignmntData.reduce((n, { wt_volume, unit }) => n + float(wt_volume) * (unit || 1), 0)
    } else {
      totalWeightVolume = consignmntData.reduce((n, { wt_volume }) => n + float(wt_volume), 0)
    }
    totalwt_actual = consignmntData.reduce((n, { wt_actual }) => n + float(wt_actual), 0)
    totalWeight = consignmntData.reduce((n, { wt_charge }) => n + float(wt_charge), 0)
    totalFreight = consignmntData.reduce((n, { freight }) => n + float(freight), 0)
  } else {
    totalFreight = consignmntData?.[0]?.freight || 0
  }
  if (IsRateIncludeAllCharge) {
    totalFreight = totalFreight - getOtherCharges(priceSectionData)
  }
  const [customerOpen, setCustomerOpen] = useState(false)
  const [gstOpen, setGstOpen] = useState(false)
  const { del_cartage, hamali, op_hamali, valuation, doc_fee, dropoff_fee, pickup_fee, gst } = priceSectionData
  const { coll_cartage, CCBrkup_pckp, CCBrkup_cmsn } = priceSectionData
  const pickDropFee = float(pickup_fee) + float(dropoff_fee)
  let totalCharges = float(coll_cartage) + float(del_cartage) + float(hamali) + float(op_hamali)
  totalCharges += float(valuation) + float(doc_fee) + float(gst) + pickDropFee
  const totalPayble = float(totalFreight) + float(totalCharges)
  const ceildTotalPayble = Math.ceil(totalPayble / 5) * 5
  let ceilValue = 0
  if (intCompanyID === STA_COMPANY_ID) {
    ceilValue = ceildTotalPayble - totalPayble
  }
  const buttonRef1 = useRef(null)
  const buttonRef2 = useRef(null)
  useEffect(() => {
    //[5702, 6064, 664].includes(intCompanyID)
    if (SetDefaultBookCargo) {
      buttonRef1.current.focus()
    } else {
      buttonRef2.current.focus()
    }
  })
  useEffect(() => {
    if (DefaultCurrencyID === 2) setGstOpen(true)
  }, [DefaultCurrencyID])
  const [calcwidth, setWidth] = useState(0)
  const widthRef = useRef(null)

  useLayoutEffect(() => {
    setWidth(widthRef.current.offsetWidth)
  }, [widthRef])
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const getvolumeWeight = (row) => {
    if (intCompanyID === STA_COMPANY_ID) {
      return `${row.wt_vlm_len || 0} X ${row.wt_vlm_wid || 0} X ${row.wt_vlm_ht || 0}`
    } else {
      return row.wt_volume
    }
  }
  let isCooldown = false
  const handleClick = () => {
    if (isCooldown) return
    isCooldown = true
    data?.yesAction && data.yesAction()
    setTimeout(() => {
      isCooldown = false
    }, 500000)
  }
  const bookWithMpesa = () => {
    data?.showMpesa && data?.showMpesa()
  }
  const bookWithUPI = () => {
    setModal('unUtilisedQrPayment')
  }
  const validatedBooking = () => {
    PostRequest(urls.getBookingValidation, data.bookingValidationObj).then((res) => {
      if (res.status === 'Success') {
        handleQrGenerate()
      } else {
        setAlert({ show: true, msg: res?.Message, nextId: '' })
      }
    })
  }
  const handleQrGenerate = async () => {
    setRemainingTime(false)
    const totalAmount = float(totalFreight) + float(totalCharges) + float(ceilValue)
    const amtToBePaid = (processingFees * totalAmount) / 100
    const finalAmt = RemoveQRTransFeeFromCustAmt
      ? float(totalFreight) + float(totalCharges) + float(ceilValue)
      : amtToBePaid + (float(totalFreight) + float(totalCharges) + float(ceilValue))
    let body = {
      agentid: 0,
      agentuserid: 0,
      amount: finalAmt,
      application: 'crs',
      branchid: loginData?.intBranchID,
      branchuserid: loginData?.intUserID,
      companyid: loginData?.intCompanyID,
      deviceid: '',
      devicetype: 'web',
      paymentmethod: 'qr',
      tag1: 'crs_cargo_booking',
      tag2: '',
      transferfee: amtToBePaid,
      vertical: 'cargo',
      checksum: '',
    }
    const saltKey = 'salt-secret'
    const checksumValue = generateChecksum(body, saltKey)
    let body1 = {
      agentid: 0,
      agentuserid: 0,
      amount: finalAmt,
      application: 'crs',
      branchid: loginData?.intBranchID,
      branchuserid: loginData?.intUserID,
      companyid: loginData?.intCompanyID,
      deviceid: '',
      devicetype: 'web',
      paymentmethod: 'qr',
      tag1: 'crs_cargo_booking',
      tag2: '',
      transferfee: amtToBePaid,
      vertical: 'cargo',
      checksum: checksumValue,
    }
    PostRequest('https://gpg.iamgds.com/api/v1/orders', body1).then(async (res) => {
      if (res?.isSuccess) {
        setQRData(res?.data?.qrUrl)
        handlePayment(res.data.orderId, 0)
      } else {
        setQRData('')
        setRemainingTime(false)
      }
    })
  }
  const handleStatus = (orderId, rechargeId) => {
    GetRequest(`https://gpg.iamgds.com/api/v1/orders/${orderId}/status`, {}).then((statusRes) => {
      if (statusRes?.isSuccess && rechargeId !== null && statusRes?.data?.status !== '') {
        let obj = {
          orderId: statusRes?.data?.orderId, //
          amount: statusRes?.data?.amount, //
          pgCharge: statusRes?.data?.pgCharge, //
          pgAmount: statusRes?.data?.pgAmount, //
          Status: statusRes?.data?.status, //confirm
          merchantTxnId: statusRes?.data?.merchantTxnId, //
          pgTxnId: statusRes?.data?.pgTxnId, //
          statusTime: statusRes?.data?.statusTime, //
          CompanyID: loginData?.intCompanyID,
          BranchID: loginData?.intBranchID,
          qrUTRNumber: statusRes?.data?.qrUTRNumber, //
          RechargeStatus: '', //confirm
          transferfee: statusRes?.data?.transferFee, //
          PaymentProductTypeID: 1,
          BusinessVerticalID: 3,
          RechargeID: rechargeId,
          EventType: 'Cargo_Booking',
          MobileNo: consignerCheck ? slctdSndParty?.MobileNo : sendMobNo,
        }
        dispatch(getDQRDetailsInsertUpdate(obj))
          .then((dispatchResult) => {
            if (dispatchResult?.status === 'Success') {
              if (statusRes.data.status === 'PAYMENT_SUCCESS') {
                setRemainingTime(false)
                clearInterval(intervalIdRef.current)
                data?.yesAction && data.yesAction({ QrOrderID: orderId, ModeOfPayment: 8 })
              } else if (statusRes.data.status === 'PAYMENT_FAILURE' || statusRes.data.status === 'PAYMENT_INITIATE_FAILED') {
                setRemainingTime(false)
                clearInterval(intervalIdRef.current)
                setAlert({ show: true, msg: 'PAYMENT FAILED', nextId: '' })
              }
            } else {
              if (dispatchResult?.status === 'Fail') {
                dispatch(updateAlertError({ show: true, msg: dispatchResult?.ErrMessage, nextId: '' }))
                handleCloseIntervals()
              }
            }
          })
          .catch((err) => {
            dispatch(updateAlertError({ show: true, msg: err, nextId: '' }))
          })
      }
    })
  }
  const initialTimeoutRef = useRef(null)
  const endTimeoutRef = useRef(null)
  const intervalIdRef = useRef(null)
  const handleCloseIntervals = () => {
    clearInterval(intervalIdRef.current)
    clearTimeout(endTimeoutRef.current)
    clearTimeout(initialTimeoutRef.current)
    intervalIdRef.current = null
    endTimeoutRef.current = null
    initialTimeoutRef.current = null
  }
  const handlePayment = async (orderId, rechargeId = 0) => {
    setRemainingTime(true)
    await handleStatus(orderId, rechargeId)

    intervalIdRef.current = setInterval(async () => {
      await handleStatus(orderId, rechargeId)
    }, 10000)
    endTimeoutRef.current = setTimeout(
      () => {
        clearInterval(intervalIdRef.current)
        intervalIdRef.current = null
        dispatch(updateAlertError({ show: true, msg: `Time Out!. Please Try Again`, nextId: '' }))
        handleCloseIntervals()
        setRemainingTime(false)
      },
      15 * 60 * 1000
    )
  }

  return (
    <Modal
      headTxt={data.headTxt ? data.headTxt : strs.bookingConfirm}
      width={'90%'}
      updateModal={updateModal}
      closeId={iid.closeButton}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Box component="div" className="booking-confirmation-wrapper">
        <Box display="flex">
          <Box sx={{ width: '100%' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', margin: '15px', boxShadow: 'none', alignItems: 'center' }}
              style={{ margin: 0 }}
              className="booking-confirmation-section"
            >
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    {strs.sourceCity}
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {strtCity?.CityName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {strs.sourceBranch}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {strtBrnch?.BranchName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {strs.senderNo}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {consignerCheck ? slctdSndParty?.MobileNo : sendMobNo}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {strs.senderName}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {consignerCheck ? slctdSndParty.Party : sendName}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Sender State & City
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {senCNnST}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    {strs.destinationCity}
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {destCity?.CityName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {strs.destinationBranch}
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    {destBrnch?.BranchName}
                  </Typography>
                </Box>
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    {strs.receiverNo}
                  </Typography>
                  :
                  <Typography ref={widthRef} className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                    {consigneeCheck ? slctdRcvrParty?.MobileNo : recMobNo}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {strs.receiverName}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {consigneeCheck ? slctdRcvrParty?.Party : recName}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Receiver State & City
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {recCNnST}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                <Box className="sr-row">
                  <Typography className="sr-label color-dark" sx={{ alignItems: 'left' }}>
                    Payment Type
                  </Typography>
                  :
                  <Typography className="sr-value color-dark" sx={{ alignItems: 'left', width: calcwidth }}>
                    {selBookingType.name}
                  </Typography>
                </Box>
                {intCompanyID !== RAJESH_TRANSPORT ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Service Type
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      Godown Delivery
                    </Typography>
                  </Box>
                ) : (
                  <></>
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    Party Bill No
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                    {billNo || 'NA'}
                  </Typography>
                </Box>
                <Box style={{ display: customerOpen ? 'block' : 'none' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Party Bill Date
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {(billDate && billDate.format('DD-MMM-YYYY')) || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Party Bill Amount
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {billAmount || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              {customerOpen ? (
                <Box className="flex-center-all bcp-link" onClick={() => setCustomerOpen(false)}>
                  <RemoveCircleIcon id="iconBox1" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link> Close Information</Link>
                </Box>
              ) : (
                <Box className="flex-center-all bcp-link" onClick={() => setCustomerOpen(true)}>
                  <AddCircleIcon id="iconBox" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link>More Information</Link>
                </Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', margin: '15px', boxShadow: 'none', alignItems: 'center' }}
              style={{ margin: 0 }}
              className="booking-confirmation-section"
            >
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                {DefaultCurrencyID !== 2 ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {strs.senderGstn}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {senGstnNo || 'NA'}
                    </Typography>
                  </Box>
                ) : (
                  ''
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    Sender ID Proof
                  </Typography>
                  :
                  <Typography className="sr-value flex" sx={{ alignItems: 'left', width: calcwidth }}>
                    {ModalData.send?.IdProof ? ModalData.send?.IdProofType?.IDProof + ' | ' + ModalData.send?.IdProof : ''}{' '}
                    {ModalData?.send?.IdProofFile ? <ImageIcon sx={{ color: 'green' }} /> : <HideImageIcon sx={{ color: 'red' }} />}
                  </Typography>
                </Box>
                <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                  {DefaultCurrencyID !== 2 ? (
                    <>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          Sender Alt. Number
                        </Typography>
                        :
                        <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                          {sendMobNo2 || 'NA'}
                        </Typography>
                      </Box>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          Sender Email ID
                        </Typography>
                        :
                        <Typography className={`sr-value ${sendMailId ? 'lowercase' : ''}`} sx={{ alignItems: 'left', width: calcwidth }}>
                          {sendMailId || 'NA'}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    ''
                  )}
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Pickup Address
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {pickupAddressObj?.formatted_address || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Pincode
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {pickupAddressObj?.pincode || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                {DefaultCurrencyID !== 2 ? (
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      {strs.receiverGstn}
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {recGstnNo || 'NA'}
                    </Typography>
                  </Box>
                ) : (
                  ''
                )}
                <Box className="sr-row">
                  <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                    Receiver ID Proof
                  </Typography>
                  :
                  <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                    NA
                  </Typography>
                </Box>
                <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                  {DefaultCurrencyID !== 2 ? (
                    <>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          Receiver Alt. Number
                        </Typography>
                        :
                        <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                          {recMobNo2 || 'NA'}
                        </Typography>
                      </Box>
                      <Box className="sr-row">
                        <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                          Receiver Email ID
                        </Typography>
                        :
                        <Typography className={`sr-value ${recMailId ? 'lowercase' : ''}`} sx={{ alignItems: 'left', width: calcwidth }}>
                          {recMailId || 'NA'}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    ''
                  )}
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Delivery Address
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {deliveryAddressObj?.formatted_address || 'NA'}
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Pincode
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      {deliveryAddressObj?.pincode || 'NA'}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {DefaultCurrencyID !== 2 ? (
                <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Operator GSTIN
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                      NA
                    </Typography>
                  </Box>
                  <Box className="sr-row">
                    <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                      Service Prov. GSTIN
                    </Typography>
                    :
                    <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                      {'NA'}
                    </Typography>
                  </Box>
                  <Box style={{ display: gstOpen ? 'block' : 'none' }}>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        Service Rcvr. GSTIN
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                        {recGstnNo || 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        Eway Bill Number
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: '100%' }}>
                        {ewayBillNoList.join(',') || 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        Eway Bill Date
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                        {ewayBillDetailsList.length
                          ? ewayBillDetailsList.map(
                              (el, index, { length }) => ewayBillDateFormat(el.EwayBillDate) + (length - 1 === index ? '' : ', ')
                            )
                          : 'NA'}
                      </Typography>
                    </Box>
                    <Box className="sr-row">
                      <Typography className="sr-label" sx={{ alignItems: 'left' }}>
                        Eway Bill Valid Upto
                      </Typography>
                      :
                      <Typography className="sr-value" sx={{ alignItems: 'left', width: calcwidth }}>
                        {ewayBillDetailsList.length
                          ? ewayBillDetailsList.map(
                              (el, index, { length }) => ewayBillDateFormat(el.ValidUpto) + (length - 1 === index ? '' : ', ')
                            )
                          : 'NA'}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Box className="sender-receiver" sx={{ width: '100%', borderRadius: '10px' }}></Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              {gstOpen ? (
                <Box className="flex-center-all bcp-link" onClick={() => setGstOpen(false)}>
                  <RemoveCircleIcon id="iconBox1" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link> Close Information</Link>
                </Box>
              ) : (
                <Box className="flex-center-all bcp-link" onClick={() => setGstOpen(true)}>
                  <AddCircleIcon id="iconBox" className="icon active" style={{ fontSize: '14px', marginRight: '5px' }} />
                  <Link>More Information</Link>
                </Box>
              )}
            </Stack>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
            </Stack>
          </Box>
          <Box sx={{ width: '300px', flexShrink: 0, textAlign: 'center' }} style={{ display: showQr ? 'block' : 'none' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'column',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  fontSize: '14px',
                  color: '#444',
                }}
                variant="h5"
              >
                Pay With UPI Qr
              </Typography>
              {QRData ? (
                <>
                  <div
                    id="qrCode"
                    className="QRimg"
                    style={{
                      display: 'flex', // Use flexbox
                      justifyContent: 'center', // Center horizontally
                      alignItems: 'center', // Center vertically
                      backgroundImage: `url(${QRData})`,
                      padding: '8px',
                      height: '168px',
                      width: '168px',
                      backgroundSize: 'cover', // Ensures the image covers the div
                      backgroundPosition: 'center', // Centers the image
                      border: '1px solid #ccc', // Optional: Add a border for better visibility
                    }}
                  />

                  {remainingTime ? <QRTimer /> : ''}
                </>
              ) : (
                <Button className="btn btn-primary" onClick={validatedBooking} disabled={disabledQr}>
                  Generate QR
                </Button>
              )}
            </div>
          </Box>
        </Box>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section"
        >
          <Box className="color-dark">Freight Calculation</Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', margin: '15px', boxShadow: 'none' }}
          className="booking-confirmation-section"
        >
          <TableContainer className="table-container" component={Paper}>
            <Table
              className="table-consignment"
              style={{ minWidth: 650 }}
              size="medium"
              sx={{ fontSize: '15px' }}
              aria-label="a dense table"
            >
              <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                <TableRow>
                  <TableCell width={'16%'}>{strs.consignmentType}</TableCell>
                  <TableCell width={'16%'}>Method of Packing</TableCell>
                  <TableCell width={'16%'}>{strs.description}</TableCell>
                  <TableCell width={'8%'} align="right">
                    Total Unit
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    Declared Value
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    Actual Weight
                  </TableCell>
                  <TableCell width={'9%'} align="right">
                    {intCompanyID === STA_COMPANY_ID ? 'Size (CFT)' : 'Volume Weight'}
                  </TableCell>
                  <TableCell width={'10%'} align="right">
                    Charged Weight
                  </TableCell>
                  <TableCell width={'8%'} align="right">
                    {strs.rate}
                  </TableCell>
                  <TableCell style={{ minWidth: '120px' }} align="right">
                    {strs.freight}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-consignment-body">
                {consignmntData?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.slctdCnsgnmntType?.SubType}</TableCell>
                    <TableCell>{item.slctdMethodOfPckgType?.MOPName}</TableCell>
                    <TableCell>{item.description}</TableCell>
                    <TableCell align="right">{item.unit}</TableCell>
                    <TableCell align="right">{item.goods_value}</TableCell>
                    <TableCell align="right">{item.wt_actual}</TableCell>
                    <TableCell align="right">{getvolumeWeight(item)}</TableCell>
                    <TableCell align="right">{item.wt_charge}</TableCell>
                    <TableCell align="right">{float(item.rate)}</TableCell>
                    <TableCell align="right">
                      {getReverseFreight(consignmntData, index, priceSectionData, IsRateIncludeAllCharge) || item.freight}
                    </TableCell>
                  </TableRow>
                ))}
                {IsMultipleConsignment && (
                  <TableRow>
                    <TableCell colSpan={3} align="right" className="color-dark">
                      {strs.total}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalUnits}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalDeclaredValue}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalwt_actual}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalWeightVolume}
                    </TableCell>
                    <TableCell align="right" className="color-dark">
                      {totalWeight}
                    </TableCell>
                    <TableCell colSpan={2} align="right" className="colored-cell">
                      {totalFreight}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section"
        >
          <Box className="color-dark">Other Charges</Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', margin: '15px', boxShadow: 'none' }}
          className="booking-confirmation-section"
        >
          <TableContainer className="table-container" component={Paper}>
            <Table
              className="table-consignment"
              style={{ minWidth: 650 }}
              size="medium"
              sx={{ fontSize: '15px' }}
              aria-label="a dense table"
            >
              <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                <TableRow>
                  {RemovePickupcartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${9}%`} align="right">
                      Pickup Cartage
                    </TableCell>
                  )}
                  {RemoveMisccartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${10}%`} align="right">
                      Mis. Cartage{' '}
                    </TableCell>
                  )}
                  {/* <TableCell width={`${9}%`} align="right">
                    Drop Cartage{' '}
                  </TableCell> */}
                  {RemoveBookingDropcartage ? (
                    <></>
                  ) : (
                    <TableCell width={`${10}%`} align="right">
                      {strs.delCartage}
                    </TableCell>
                  )}
                  {RemoveHamali ? (
                    <></>
                  ) : (
                    <TableCell width={`${5}%`} align="right">
                      {strs.hamali}
                    </TableCell>
                  )}
                  {RemoveOpHamali ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      {strs.opHamali}
                    </TableCell>
                  )}
                  {RemoveDocfee ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      Document
                    </TableCell>
                  )}
                  {RemoveValuation ? (
                    <></>
                  ) : (
                    <TableCell width={`${7}%`} align="right">
                      {DefaultCurrencyID === 2 ? strs.insurance : strs.valuation}
                    </TableCell>
                  )}
                  {RemovePickupfee ? (
                    <></>
                  ) : (
                    <TableCell width={`${6}%`} align="right">
                      Pickup
                    </TableCell>
                  )}
                  {RemoveDropofffee ? (
                    <></>
                  ) : (
                    <TableCell width={`${6}%`} align="right">
                      Dropoff
                    </TableCell>
                  )}
                  {intCompanyID === STA_COMPANY_ID ? (
                    ''
                  ) : (
                    <TableCell width={`${9}%`} align="right">
                      Conv. Charge
                    </TableCell>
                  )}
                  {DefaultCurrencyID !== 2 && IsServiceTax ? (
                    <TableCell width={`${7}%`} align="right">
                      Booking GST
                    </TableCell>
                  ) : (
                    ''
                  )}
                  <TableCell width={`${9}%`} align="right">
                    {strs.totalCharges}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="table-consignment-body">
                <TableRow>
                  {RemovePickupcartage ? <></> : <TableCell align="right">{float(CCBrkup_pckp)}</TableCell>}
                  {RemoveMisccartage ? <></> : <TableCell align="right">{float(CCBrkup_cmsn) + float(ceilValue)}</TableCell>}
                  {/* <TableCell align="right">{float(CCBrkup_rtrn)}</TableCell> */}
                  {RemoveBookingDropcartage ? <></> : <TableCell align="right">{float(del_cartage)}</TableCell>}
                  {RemoveHamali ? <></> : <TableCell align="right">{float(hamali)}</TableCell>}
                  {RemoveOpHamali ? <></> : <TableCell align="right">{float(op_hamali)}</TableCell>}
                  {RemoveDocfee ? <></> : <TableCell align="right">{float(doc_fee)}</TableCell>}
                  {RemoveValuation ? <></> : <TableCell align="right">{float(valuation)}</TableCell>}
                  {RemovePickupfee ? <></> : <TableCell align="right">{float(pickup_fee)}</TableCell>}
                  {RemoveDropofffee ? <></> : <TableCell align="right">{float(dropoff_fee)}</TableCell>}
                  {intCompanyID === STA_COMPANY_ID ? '' : <TableCell align="right">{0}</TableCell>}
                  {DefaultCurrencyID !== 2 && IsServiceTax ? <TableCell align="right">{float(gst)}</TableCell> : ''}
                  <TableCell align="right">{float(totalCharges) + float(ceilValue)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
          className="booking-confirmation-section summary-item"
        >
          <Box sx={{ width: '40%' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box className="color-dark">Mode of Payment</Box>
            </Stack>
            <TableContainer className="table-container" component={Paper}>
              <Table className="table-consignment" size="medium" sx={{ fontSize: '15px' }} aria-label="a dense table">
                <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                  <TableRow>
                    {RemovePaymentMode ? (
                      <></>
                    ) : (
                      <TableCell width={`${50}%`} className="colored-cell large-font">
                        Payment Mode
                      </TableCell>
                    )}
                    {RemoveAccountnumber ? (
                      <></>
                    ) : (
                      <TableCell width={`${50}%`} className="colored-cell large-font">
                        Bank Account Number
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody className="table-consignment-body">
                  <TableRow>
                    {RemovePaymentMode ? (
                      <></>
                    ) : (
                      <TableCell className="colored-cell large-font">{data?.selectedMethod?.ModeName}</TableCell>
                    )}
                    {RemoveAccountnumber ? (
                      <></>
                    ) : (
                      <TableCell className="colored-cell large-font">{data?.accountNo?.AccountNo || 'N/A'}</TableCell>
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ width: '60%' }} style={{ marginLeft: '10px' }}>
            <Stack
              component={Paper}
              direction="row"
              spacing={2}
              sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
              className="booking-confirmation-section"
            >
              <Box className="color-dark">Gross LR Amount</Box>
            </Stack>
            <TableContainer className="table-container" component={Paper}>
              <Table className="table-consignment" size="medium" sx={{ fontSize: '15px' }} aria-label="a dense table">
                <TableHead className="table-consignment-head" style={{ position: `sticky`, top: `0`, background: `#e5f3fa` }}>
                  <TableRow>
                    <TableCell width={`${100 / 3}%`} align="right">
                      Total Freight
                    </TableCell>
                    <TableCell width={`${100 / 3}%`} align="right">
                      Other Charges
                    </TableCell>
                    <TableCell width={`${100 / 3}%`} align="right" className="colored-cell large-font">
                      Gross LR Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="table-consignment-body">
                  <TableRow>
                    <TableCell align="right">{float(totalFreight)}</TableCell>
                    <TableCell align="right">{float(totalCharges) + float(ceilValue)}</TableCell>
                    <TableCell align="right" className="colored-cell large-font">
                      {float(totalFreight) + float(totalCharges) + float(ceilValue)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Stack>
        <Stack
          component={Paper}
          direction="row"
          spacing={2}
          style={{ margin: '0 0 10px' }}
          sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center', margin: 0, justifyContent: 'space-between' }}
          className="booking-confirmation-section"
        >
          <Box>
            <p className="bold">Remarks</p>
            <p>NA</p>
          </Box>
          {CCR && !RemoveCartageremark ? (
            <Box>
              <p className="bold">Cartage Remarks</p>
              <p>{cmnt}</p>
            </Box>
          ) : (
            ''
          )}
          {cmnt && !RemoveComment ? (
            <Box>
              <p className="bold">Comments </p>
              <p>{cmnt}</p>
            </Box>
          ) : (
            ''
          )}
        </Stack>
      </Box>
      <Box sx={{ width: '100%', height: '2px', background: '#ccc' }}></Box>
      <Box component="div" className="modal-btn-grp confirm-poup-grp" style={{ display: data?.hideContols ? 'none' : 'flex' }}>
        <Button
          ref={buttonRef2}
          className="btn cancel-btn margin-normal"
          variant="outlined"
          onClick={() => {
            setQRData('')
            data?.noAction()
            setTimeout(() => {
              focusElemnt('bookCargoButton')
            }, 3)
          }}
          onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
        >
          Close
        </Button>
        {DefaultCurrencyID === 2 ? (
          <Button className="btn btn-primary margin-normal" onClick={bookWithMpesa} onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}>
            Book With M-Pesa
          </Button>
        ) : (
          ''
        )}
        {DefaultCurrencyID !== 2 && showQr ? (
          <Button
            className="btn btn-primary margin-normal"
            onClick={bookWithUPI}
            onKeyDown={(e) => successPopUpKeyDown(e, buttonRef1)}
            disabled={disabledQr}
          >
            UnUtilised Payment Booking
          </Button>
        ) : (
          ''
        )}
        <Button
          ref={buttonRef1}
          className="btn btn-primary margin-normal"
          onClick={handleClick}
          disabled={!!QRData}
          onKeyDown={(e) => successPopUpKeyDown(e, buttonRef2)}
        >
          Book Cargo
        </Button>
      </Box>
    </Modal>
  )
}
